import { useBuildAppLinkActionHook } from './appLinkActionBuilder';
export function usePageAppLinkAction(linkArgs) {
  return useBuildAppLinkActionHook('PAGE', linkArgs);
}